<template>
  <div class="select-container">
    <label v-if="label" :for="uuid">
      {{ label }}
    </label>
    <select
      class="field"
      v-bind="{
        ...$attrs,
        onChange: updateValue,
      }"
      :value="modelValue"
      :id="uuid"
    >
      <option v-for="option in options" :value="option.value" :key="option.id" :selected="option === modelValue" :disabled="option.disabled">
        {{ option.label }}
      </option>
    </select>
  </div>
</template>

<script setup>
  const props = defineProps({
    uuid: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      default: "",
    },
    modelValue: {
      type: [String, Number],
    },
  })
  const emit = defineEmits({ "update:modelValue": String, change: String })
  const updateValue = (event) => {
    emit("update:modelValue", event.target.value)
    emit("change", event.target.value)
  }

  //const { updateValue } = SetupFormComponent(props, emit)
</script>
<style>
  select {
    font-size: 1.1rem;
    padding: 14px;
  }

  .select-container {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
</style>
